import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Text } from "@chakra-ui/react";
import { Protect } from "@airhelp/icons";
export const ConsumerRights = ({ text, ...props }) => (_jsxs(Badge, { display: "flex", alignItems: "center", ...props, children: [_jsx(Protect, { mr: 2, boxSize: 6, color: "primary.500" }), _jsx(Text, { fontSize: "sm", fontWeight: "bold", color: "primary.500", children: text })] }));
